

import React, {Component} from 'react';
import './Message.css';
import {Launcher} from 'react-chat-window'
export default class Message extends Component {
  state={
    dbUpdate:[]
  }
  render() {
   // console.log(this.props.user)
    return (
     
      <div className="message" >     
                <span className="message__author">                
              <h5 style={{color:'white'}}>{this.props.message}</h5>  
                <br/>
               <h5 style={{color:'white'}}>{this.props.user}</h5> 
                <br/>               
                </span>
                          
      </div>
    
    )
  }
}

/*


<i className="sign-in"
<i className="sign-in"
<i className="sign-in"<i className="sign-in"


*/